// extracted by mini-css-extract-plugin
export default {"label":"AddressInputs_label__tMViV","address_text":"AddressInputs_address_text__-ZlHs","wrapCopyAddressButton":"AddressInputs_wrapCopyAddressButton__t+Hks"};